import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Surgicals extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Quirurgicos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerSurgicalsBackgroundRadio(e.target.value, 'quirurjico');
                                        }}
                                        row aria-label="position"
                                        id="radio-surgical-quirurjico"
                                        name="radio-surgical-quirurjico"
                                        value={this.props.sectionAilment.surgicals.quirurjico.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.surgicals.quirurjico.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.surgicals.quirurjico.comentario}
                                    onChange={(e) => {
                                        this.props.handlerSurgicalsBackgroundText(e.target.value, 'quirurjico');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div className="form">
                        <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                        <div className="form__form-group-field">
                            <textarea
                                id="textarea-observation"
                                value={this.props.sectionAilment.surgicals.observacion}
                                disabled={this.props.stateClinicHistory}
                                name="textarea-surgical"
                                onChange={(e) => {
                                    this.props.handlerSurgicalsBackgroundObservation(e.target.value, 'observacion');
                                }}
                            >
                            </textarea>
                        </div>
                    </div>
                </Row>
            </Fragment>
        );
    }
}

export default Surgicals;
